<template>
  <nuxt-link :to="localePath(redirectLink)" class="link" exact>
    <component :is="currentIcon" class="link__icon"/>
    <slot/>
  </nuxt-link>
</template>

<script>
import Wallet from '~/static/img/profile/wallet.svg';
import User from '~/static/img/profile/user.svg';
import Document from '~/static/img/icons/document.svg';
import Nuxt from '~/static/img/icons/nuxt.svg';
import { iconsEnum } from '~/app/shared/utils/consts';

export default {
  name: 'ProfileMenuLink',
  components: { Wallet, User, Document, Nuxt },
  props: {
    redirectLink: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
      validate: value => {
        return [iconsEnum.wallet, iconsEnum.user, iconsEnum.document].includes(value);
      },
    },
  },
  computed: {
    iconsList() {
      return [
        { label: iconsEnum.wallet, iconName: Wallet },
        { label: iconsEnum.user, iconName: User },
        { label: iconsEnum.document, iconName: Document },
      ];
    },
    currentIcon() {
      const result = this.iconsList.find(item => item.label === this.icon);
      return Object.keys(result).length > 0 ? result.iconName : Nuxt;
    },
  },
};
</script>

<style scoped lang="scss">
.link {
  display: flex;
  align-items: center;

  &__icon {
    @include square(20px);
    margin-right: map-get($margins, small);
  }
}
</style>
